import type { Action } from 'redux'
import type { StreamDefinition } from '../../../signalr/types'
import { defaultGetParams as getParams } from '../../../signalr/helpers'
import { aggressAttemptAddAggressAttempt } from './actions'
import type { AggressAttempt } from './types'

export const fetchAggressAttemptDefinition: StreamDefinition<
  [],
  AggressAttempt[],
  Action
> = {
  method: 'GetAggressAttempts',
  strategy: 'switch',
  getParams,
  mapResponse: aggressAttemptAddAggressAttempt,
  errorAction: 'aggressAttempts.fetchFail',
  cancelOn: ['aggressAttempts.fetchCancel']
}
